<template>
  <div class="indexa">
    <!-- AIBOX-->
    <div v-if="language==1">
      <div class="indexa_box">
        <img src="../../../static/bg/polarisTripRECbg.png" alt="">
      </div>
      <div style="width:800px;margin:0 auto;margin-bottom:100px;">
        <el-carousel :interval="4000" type="card" height="360px" width="400px">
          <el-carousel-item v-for="item in imgArr" :key="item">
            <img :src="item" alt="" style="width:100%;height:100%;">
          </el-carousel-item>
        </el-carousel>
      </div>
      </div>
      <div v-if="language==0">
        <div class="indexa_box">
          <img src="../../../static/bg/polarisTripRECbgEng.png" alt="">
        </div>
        <div style="width:800px;margin:0 auto;margin-bottom:100px;">
          <el-carousel :interval="4000" type="card" height="360px" width="400px">
            <el-carousel-item v-for="item in imgArrEng" :key="item">
              <img :src="item" alt="" style="width:100%;height:100%;">
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>

    </div>
</template>

<script>
export default {
  name: "AIBOX",
  data() {
    return {
      imgArr: [
        "../../../static/activeSafety/slideshow1.png",
        "../../../static/activeSafety/slideshow2.png",
        "../../../static/activeSafety/slideshow3.png",
        "../../../static/activeSafety/slideshow4.png",
        "../../../static/activeSafety/slideshow6.png"
      ],
      imgArrEng: [
        "../../../static/activeSafety/slideshowEng1.png",
        "../../../static/activeSafety/slideshowEng2.png",
        "../../../static/activeSafety/slideshowEng3.png",
        "../../../static/activeSafety/slideshowEng4.png",
        "../../../static/activeSafety/slideshowEng6.png"
      ],
    };
  },
  mounted() {
   
  },
  computed: {
    language() {
        // 1中文，0英文
      return this.$store.state.langurage;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.indexa_box {
  margin: 0 auto;
}
img {
  width: 100%;
}

</style>



// WEBPACK FOOTER //
// src/components/Product/AIBOX.vue